import { InjectionToken } from '@angular/core';
import { CancelQuoteDialogConfig } from '../interfaces/cancel-quote-dialog-config.interface';

export const CANCEL_QUOTE_DIALOG_CONFIG = new InjectionToken<CancelQuoteDialogConfig>('CANCEL_QUOTE_DIALOG_CONFIG');
